import { watch, ref, onUnmounted } from 'vue'
import router from '@/router'

import { useFormStore } from '@/stores/form'
import lookups from '@/assets/json/clientLookups.json'
import { useGlobalStore } from '@/stores/global'
import axios from '@/services'

const educationLevelWatch = (id) => {
  const educationLevelIdWatch = ref()
  const formStore = useFormStore()
  const { lowerSecondaryEducation, upperSecondaryEducation, diploma, bachelor, master, doctoral } =
    lookups.educationLevels

  educationLevelIdWatch.value = watch(
    () => formStore.form.values.educationLevelId,
    (newVal) => {
      if (newVal) {
        if ([lowerSecondaryEducation, upperSecondaryEducation].includes(newVal)) {
          formStore.extraMap.showEducationCountry = true
          formStore.extraMap.showEducationDetails = false
        } else if ([diploma, bachelor, master, doctoral].includes(newVal)) {
          formStore.extraMap.showEducationCountry = true
          formStore.extraMap.showEducationDetails = true
        } else {
          formStore.extraMap.showEducationCountry = false
          formStore.extraMap.showEducationDetails = false
        }
        if (formStore.draft.request.monthlyIncome) {
          let newMonthlyIncome = formStore.draft.request.monthlyIncome.replace(/^0+/, '')
          formStore.draft.request.monthlyIncome = newMonthlyIncome
          formStore.form.setFieldValue('monthlyIncome', newMonthlyIncome)
        }
      }
    }
  )
  onUnmounted(() => {
    educationLevelIdWatch.value && educationLevelIdWatch.value()
  })
}
const professionsWatch = () => {
  const professionsIdWatch = ref()
  const formStore = useFormStore()
  const {
    ServiceTransactions: {
      SearchForJobVisa60DaysSingleEntryIssue,
      SearchForJobVisa90DaysSingleEntryIssue,
      SearchForJobVisa120DaysSingleEntryIssue
    },
    professionSkillLevelType: { noLevelDefined }
  } = lookups
  const { serviceTransactionId } = formStore.extraMap
  professionsIdWatch.value = watch(
    () => formStore.form.values.professionId,
    async (newVal) => {
      if (!newVal) {
        formStore.extraMap.showUniversities = false
        formStore.form.setFieldValue('universityId', null)
      }

      if (
        newVal &&
        [
          SearchForJobVisa60DaysSingleEntryIssue,
          SearchForJobVisa90DaysSingleEntryIssue,
          SearchForJobVisa120DaysSingleEntryIssue
        ].includes(serviceTransactionId)
      ) {
        let res = await axios.request({
          url: `/api/draft/GetProfessionSkillLevel/${newVal}`,
          method: 'GET'
        })

        if (res == noLevelDefined) {
          formStore.extraMap.showUniversities = true
        } else {
          formStore.extraMap.showUniversities = false
          formStore.draft.request.universityId = null
          formStore.form.setFieldValue('universityId', null)
        }
      }
    }
  )
  onUnmounted(() => {
    professionsIdWatch.value && professionsIdWatch.value()
  })
}

const checkConductIdentificationCodeCertificate = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { showConductIdentificationCodeCertificate } = globalStore.startedService
  const { dateOfBirth, currentNationalityId, passportNumber, passportTypeId, personUnifiedNumber } =
    formStore.draft.request
  if (
    showConductIdentificationCodeCertificate &&
    dateOfBirth &&
    ((currentNationalityId && passportNumber && passportTypeId) || personUnifiedNumber)
  ) {
    let params = {
      unifiedNumber: personUnifiedNumber,
      passportNumber,
      passportTypeId,
      currentNationalityId,
      dateOfBirth
    }
    let res = await axios.request({
      url: '/api/requestmaster/showConductIdentificationCodeCertificate',
      method: 'POST',
      data: params
    })
    if (res) {
      formStore.extraMap.showConductIdentificationCodeCertificate = res
    } else {
      formStore.draft.request.conductIdentificationCodeCertificate = null
      formStore.form.setFieldValue('conductIdentificationCodeCertificate', null)
      formStore.extraMap.showConductIdentificationCodeCertificate = false
    }
  } else {
    formStore.draft.request.conductIdentificationCodeCertificate = null
    formStore.form.setFieldValue('conductIdentificationCodeCertificate', null)
    formStore.extraMap.showConductIdentificationCodeCertificate = false
  }
}
const currentNationalityWatch = () => {
  const formStore = useFormStore()
  const currentNationalityIdWatch = ref()
  currentNationalityIdWatch.value = watch(
    () => formStore.form.values.currentNationalityId,
    async (newVal) => {
      checkConductIdentificationCodeCertificate()
    }
  )
  onUnmounted(() => {
    currentNationalityIdWatch.value && currentNationalityIdWatch.value()
  })
}
const passportTypesWatch = () => {
  const passportTypeIdWatch = ref()
  const formStore = useFormStore()
  passportTypeIdWatch.value = watch(
    () => formStore.form.values.passportTypeId,
    async (newVal) => {
      checkConductIdentificationCodeCertificate()
    }
  )
  onUnmounted(() => {
    passportTypeIdWatch.value && passportTypeIdWatch.value()
  })
}

export default function () {
  return {
    educationLevelWatch,
    professionsWatch,
    currentNationalityWatch,
    passportTypesWatch
  }
}
